import { render, staticRenderFns } from "./BuyerVoucher.vue?vue&type=template&id=311bdd32&scoped=true"
import script from "./BuyerVoucher.vue?vue&type=script&lang=js"
export * from "./BuyerVoucher.vue?vue&type=script&lang=js"
import style0 from "./BuyerVoucher.vue?vue&type=style&index=0&id=311bdd32&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311bdd32",
  null
  
)

export default component.exports